// Runtime config from /config.json (per-instance, mounted via Kubernetes ConfigMap).
// Loaded once before the app boots — see main.tsx.
let runtime: {
  apiBase?: string;
  amazon?: {
    applicationId?: string;
    redirectUri?: string;
    redirectName?: string;
  };
} = {};

export async function loadRuntimeConfig(): Promise<void> {
  try {
    const res = await fetch('/config.json', { cache: 'no-store' });
    if (res.ok) runtime = await res.json();
  } catch {
    // No config.json available (e.g. local dev) — getters fall back to import.meta.env.
  }
}

export const env = {
  get apiBaseUrl(): string {
    return runtime.apiBase || import.meta.env.VITE_API_BASE_URL || 'http://localhost:5001';
  },
  turnstileSiteKey: import.meta.env.VITE_TURNSTILE_SITE_KEY || '',
  sentryDsn: import.meta.env.VITE_SENTRY_DSN || '',
  amazon: {
    get applicationId(): string {
      return runtime.amazon?.applicationId || import.meta.env.VITE_AMAZON_APPLICATION_ID || '';
    },
    get redirectUri(): string {
      return runtime.amazon?.redirectUri || import.meta.env.VITE_AMAZON_REDIRECT_URI || '';
    },
    get redirectName(): string {
      return runtime.amazon?.redirectName || import.meta.env.VITE_AMAZON_REDIRECT_NAME || '';
    },
  },
};
